import BusinessOwnershipStructure from "./BusinessOwnershipStructurePage";

export default BusinessOwnershipStructure;
